import React from 'react';

interface SelectContextType {
  multiple?: boolean;
}

export const SelectContext = React.createContext<SelectContextType>({ multiple: false });
